import {
    Crown, TreeEvergreen, TreeStructure, ShieldStar, Buildings, Leaf,
    Users, GearSix, ChartLineUp, MapTrifold, PawPrint, Binoculars, UserCircle,
} from '@phosphor-icons/react';

const roleVisuals = {
    SECRETARY: [Crown, '#b8872c', '#fff3d9'],
    DFO: [TreeEvergreen, '#32835a', '#e6f4eb'],
    CF: [TreeStructure, '#328e92', '#e5f5f4'],
    CCF: [ShieldStar, '#6954ad', '#eeebfa'],
    DG: [Buildings, '#3d75b7', '#e8f0fc'],
    SO_FOREST: [Leaf, '#6a923b', '#f0f6e5'],
    AS_ADMIN: [Users, '#96704c', '#f7eee6'],
    AS_TECH: [GearSix, '#6e7c9b', '#edf0f7'],
    AS_PMAE: [ChartLineUp, '#ac6b3b', '#fbefe4'],
    GIS_LAB_MANAGER: [MapTrifold, '#3998a8', '#e4f5f8'],
    DS_WILDLIFE: [PawPrint, '#a45b89', '#faeaf3'],
    DCWR_LAHORE_HQ: [Binoculars, '#658a43', '#edf5e6'],
    INDIVIDUAL: [UserCircle, '#5b7dba', '#eaf1fc'],
};

const OfficerRoleIcon = ({ role }) => {
    const [Glyph, color, background] = roleVisuals[role] || roleVisuals.INDIVIDUAL;
    return <Glyph weight="duotone" size={24} aria-hidden="true" className="officer-role-icon" style={{ '--officer-icon-color': color, '--officer-icon-bg': background }} />;
};

export default OfficerRoleIcon;
